import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import { filterButtonSx } from '../../common/sharedStyles'

/**
 * Small confirmation used by every Internal Alerts mutation. `children` is the explanation (what will happen and to
 * whom). `withReason` adds an optional free-text reason that goes into the change log; `reasonRequired` makes it
 * mandatory (used when removing the last recipient or switching an alert off).
 */
export default function ConfirmDialog({ open, title, children, confirmLabel = 'Confirm', tone = 'primary', withReason = false, reasonRequired = false, reasonLabel, busy = false, onCancel, onConfirm }) {
  const [reason, setReason] = useState('')
  useEffect(() => { if (open) setReason('') }, [open])
  const color = tone === 'error' ? 'error' : tone === 'warning' ? 'warning' : 'primary'
  const canConfirm = !busy && (!reasonRequired || reason.trim().length > 0)

  return (
    <Dialog open={open} onClose={busy ? undefined : onCancel} maxWidth='xs' fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component='div' sx={{ color: 'text.secondary', fontSize: 14 }}>{children}</DialogContentText>
        {withReason && (
          <TextField
            autoFocus fullWidth size='small' multiline minRows={2} sx={{ mt: 2 }}
            label={reasonLabel || (reasonRequired ? 'Reason' : 'Reason (optional)')}
            value={reason} onChange={(e) => setReason(e.target.value)}
            inputProps={{ maxLength: 300 }}
            helperText={reasonRequired && !reason.trim() ? 'A reason is required — it goes into the change log.' : 'Recorded in the change log.'}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button size='small' sx={filterButtonSx('reset')} onClick={onCancel} disabled={busy}>Cancel</Button>
        <Button size='small' variant='contained' color={color} onClick={() => onConfirm(reason.trim() || undefined)} disabled={!canConfirm} sx={{ textTransform: 'none', fontWeight: 600 }}>
          {busy ? 'Saving…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
